<div id="permitConfirm">
  <ngx-loading [show]="pageload"></ngx-loading>
  <app-busy class="col-12" *ngIf="pageload2" [message]="message"></app-busy>
  <div class="container-fluid Confirmation-invoice">
    <div class="content" #content id="PDFcontent">
      <h4 style="text-align: Left; font-weight: bold">
        Permit Approval :
        <span style="font-weight: 200; font-size: 85%">{{
          dataCntrl["permittype"].description
        }}</span>
      </h4>
      <br />
      <div class="confirmation-block" id="confirm-content">
        <div class="col-md-12 p-0 row">
          <div class="col-md-10 row p-0">
            <div class="col-sm-6">
              <h4 style="margin-bottom: -5px; padding-left: 3%">
                <span style="padding-right: 5px"></span>
                <b>1. Carrier Details</b>
              </h4>
            </div>

            <!--  <div class="col-sm-6">
              <h6 style="margin-bottom:20px;padding-left:0%">
                <span style="padding-right:5px"></span>
                <i class="fa fa-map-marker"></i>
                <b>Physical Address</b>
              </h6>
            </div>-->
          </div>
        </div>
        <div class="under-line"></div>
        <!-- <div class="col-md-2">
            <h6 style="margin-bottom:20px;">
              <b>Document Uploads</b>
            </h6>
          </div> -->
        <div class="row mb-3 col-md-12">
          <div style="margin-bottom: 10px" class="col-sm-5 p-0">
            <div class="col-md-10">
              <table class="table-1" id="pdfTable-1">
                <tbody>
                  <br />
                  <tr>
                    <td>
                      <span class="head-text"><b>Carrier Number : </b></span>
                    </td>
                    <td width="auto">
                      <span class="pl-2">{{
                        dataCntrl["carrier"].carrier_code
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="head-text"><b>Carrier Name : </b></span>
                    </td>
                    <td>
                      <span class="pl-2">{{ dataCntrl["carrier"].name }}</span>
                    </td>
                  </tr>
                  <!-- <tr>
                     <td><span class = "head-text"><b>Trading Name: </b></span></td>
                     <td><span class="pl-2"> {{dataCntrl['carrier'].trading_name}}</span></td>
                   </tr> -->
                  <tr>
                    <td>
                      <span class="head-text"><b>Telephone No : </b></span>
                    </td>
                    <td *ngIf="dataCntrl['carrier'].country_dial_code != ''">
                      <span class="pl-2"
                        >+{{ dataCntrl["carrier"].country_dial_code }}
                        {{ dataCntrl["carrier"].telephone }}</span
                      >
                    </td>
                    <td *ngIf="dataCntrl['carrier'].country_dial_code == ''">
                      <span class="pl-2"
                        >({{ dataCntrl["carrier"].country_code }})
                        {{ dataCntrl["carrier"].telephone }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="head-text"><b>Email Address : </b></span>
                    </td>
                    <td>
                      <span class="pl-2">{{ dataCntrl["carrier"].email }}</span>
                    </td>
                  </tr>
                  <!-- <tr>
                     <td><span class = "head-text">Permit Application Nnumber:</span></td>
                     <td><span class="pl-2">{{dataCntrl['carrier'].carrier_code}}</span></td>
                   </tr>
                   <tr>
                     <td><span class = "head-text">Application Date:</span></td>
                     <td><span class="pl-2">{{dataCntrl['application'].date_created | date :'dd-MM-yyyy'}}</span></td>
                   </tr>-->
                </tbody>
              </table>
            </div>
          </div>
          <div
            style="
              margin-left: 0px;
              margin-bottom: 10px;
              float: right;
              position: relative;
              left: 250px;
            "
            class="col-sm-5 p-0"
          >
            <div class="col-md-10">
              <h6></h6>
              <table
                class="table-1"
                id="pdfTable-1"
                style="margin-left: 30px; margin-top: -5px"
              >
                <!-- <tbody>
                     <tr>
                        <td><h6>Physical Address</h6></td>
                    </tr>
                  </tbody> -->
                <br />
                <tbody>
                  <tr>
                    <td class="addrees-td-1" width="auto;">
                      <span class="head-text"><b>Street Name : </b></span>
                    </td>
                    <td class="addrees-td" width="auto">
                      <span class="pl-2">{{
                        dataCntrl["carrier"].physical_address_1
                      }}</span>
                    </td>
                  </tr>
                  <!--                                    
                    <tr>
                      <td class="addrees-td-1"><span class = "head-text">Address Line2:</span></td>
                      <td class="addrees-td"><span class="pl-2">{{dataCntrl['carrier'].physical_address_2}}</span></td>
                    </tr>
                    <tr>
                      <td class="addrees-td-1"><span class = "head-text">Address Line3:</span></td>
                      <td class="addrees-td"><span class="pl-2">{{dataCntrl['carrier'].physical_address_3}}</span></td>
                    </tr>
  -->
                  <tr>
                    <td class="addrees-td-1">
                      <span class="head-text"><b>Town : </b></span>
                    </td>
                    <td class="addrees-td">
                      <span class="pl-2">{{
                        dataCntrl["carrier"].physical_address_town
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="addrees-td-1">
                      <span class="head-text"><b>Postal Code : </b></span>
                    </td>
                    <td class="addrees-td">
                      <span class="pl-2">{{
                        dataCntrl["carrier"].physical_post_code
                      }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="addrees-td-1">
                      <span class="head-text"><b>Country : </b></span>
                    </td>
                    <td class="addrees-td">
                      <span class="pl-2">{{
                        dataCntrl["carrier"].country_description
                      }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <hr />
        <div>
          <h4><b>2. Permit Details</b></h4>
          <div class="under-line"></div>
        </div>
        <app-modify-details [routeDetials]="routeDetials"></app-modify-details>
        <div *ngIf="dataCntrl.permittype.annual_compliance_reqd">
          <hr />
          <div>
            <h4><b>2.1 Annual Compliance Details</b></h4>
            <div class="under-line"></div>
          </div>
          <table class="table" id="cpdfTable" style="margin-left: 15px">
            <thead>
              <tr>
                <th>Permit Type</th>
                <th>End Date</th>
                <th>Year</th>
                <th>Vehicle Reg</th>
                <th>Vehice Type</th>
                <!-- <th >License Expiry Date</th> -->
                <!--  <th>GVM</th> -->
                <th>VIN Number</th>
                <th>Status</th>
                <th>Application Fee</th>
                <th>Permit Fee</th>
                <th>Line Total</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let clist of complianceCertficateList">
                <td>{{ clist.PermitType }}</td>
                <td>{{ clist.ComplianceEndDate | date : "dd/MM/yyyy" }}</td>
                <td>{{ clist.Year }}</td>
                <td>{{ clist.RegistrationNumber }}</td>
                <td>{{ clist.vehicle_type }}</td>
                <td>{{ clist.Vin }}</td>
                <td>{{ clist.ComplianceStatusDescription }}</td>
                <td>{{ formatCurrency(clist.ApplicationFee) }}</td>
                <td>{{ formatCurrency(clist.PermitFee) }}</td>
                <td>
                  {{ formatCurrency(clist.ApplicationFee + clist.PermitFee) }}
                </td>
              </tr>
              <!-- <tr>
                 <td colspan="8" style="text-align:right;">Total :</td>

                 <td> {{formatCurrency(clist.LineTotal)}}</td>
               </tr> -->

              <br />
            </tbody>
          </table>
        </div>

        <div>
          <h4><b>3. Route Details</b></h4>
          <div class="under-line"></div>
        </div>
        <div class="col-md-12 p-0">
          <route-viewer
            [dataCntrl]="dataCntrl"
            [routeDetials]="routeDetials"
          ></route-viewer>
        </div>

        <div *ngIf="dataCntrl.permittype.timetable_reqd">
          <h4><b>3.1 Time Table Details</b></h4>
        </div>
        <div *ngIf="dataCntrl.permittype.timetable_reqd" class="col-md-12 p-0">
          <app-permit-timetable [isEditing] = false
            [dataCntrl]="dataCntrl"
          ></app-permit-timetable>
        </div>

        <div>
          <h4><b>4. Motivation</b></h4>
          <div class="under-line"></div>
        </div>
        <div class="col-md-12 p-0 mb-5">
          <motivation-viewer
            [dataCntrl]="dataCntrl"
            [routeDetials]="routeDetials"
          >
          </motivation-viewer>
        </div>

        <div>
          <h4><b>5. Supporting Documents</b></h4>
          <div class="under-line"></div>
        </div>
        <div style="z-index: 9999">
          <uploads-viewer
            id="suppDocs"
            name="suppDocs"
            isPermitApproval="true"
            [dataCntrl]="dataCntrl"
          ></uploads-viewer>
        </div>
      </div>
      <div *ngIf="dataCntrl.permittype.annual_compliance_reqd">
        <div>
          <h4><b>6. Compliance Documents</b></h4>
        </div>
        <div *ngFor="let comps of complianceCertficateList">
          <div>
            <h6>
              <b
                >Permit Number: {{ comps.PermitNumber }} | Vehicle:
                {{ comps.RegistrationNumber }} | Compliance Year:
                {{ comps.Year }}</b
              >
            </h6>
          </div>
          <div
            class="col-md-12 p-0 mb-5"
            *ngIf="routheDetials === 'application'"
          >
            <uploads-viewer
              id="comps.ComplianceDetailId"
              name="comps.ComplianceDetailId"
              isPermitApproval="true"
              isComplianceDocuments="true"
              [complianceDetailId]="comps.ComplianceDetailId"
              [dataCntrl]="dataCntrl"
            ></uploads-viewer>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="col-md-12 p-0" id="ignoreContent">
         <button title="Download PDF" name="download" type="submit" id="btnSave" (click)="downloadPdf()"  class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:0px;margin-bottom:5px;  ">Download PDF</button>
     </div>-->
  </div>
</div>
